import { BigNumber } from "shared/cubiq-model-multi-asset";

import { NumericAdapter } from "../NumericAdapter";

import { PricingService } from "../../lookup/pricing/PricingService";

export class RateAdapter extends NumericAdapter {
  protected pricingService: PricingService;
  protected dealtMode: boolean;
  protected pinTriggeredEnabled: boolean = true;
  constructor(pricingService: PricingService, dealtMode: boolean) {
    super();
    this.pricingService = pricingService;
    this.dealtMode = dealtMode;
  }

  getValue(order: any, columnProperty: string): string {
    if (this.pricingService) {
      let value = this.pricingService.getOrderRequestRt(order);
      if (BigNumber.isBigNumber(value)) {
        return value.toString();
      }
      return value;
    }
    return String(order[columnProperty]);
  }

  retrieveData(order: any, columnProperty: string): string {
    let rate = this.getValue(order, columnProperty);
    return rate;
  }

  retrieveSort(order: any, columnProperty: string): any {
    let value: string = this.getValue(order, columnProperty);
    if (value && value != "-" && value != " ") return Number(value).toString();
    return "";
  }

  retrieveSearch(order: any, columnProperty: string): any {
    let rate = this.getValue(order, columnProperty);

    return rate;
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return this.getValue(order, columnProperty);
  }

  protected mapUserSettings(profileValue: any) {
    if (profileValue) {
      let savedSettings = JSON.parse(profileValue);
      if (savedSettings != undefined && savedSettings != null) {
        this.pinTriggeredEnabled =
          savedSettings.hasOwnProperty("pinTriggeredOrdersModel") &&
          savedSettings.pinTriggeredOrdersModel !== null &&
          savedSettings.pinTriggeredOrdersModel == "y"
            ? true
            : false;
      }
    }
  }
}
